import { Flex, Loader } from "@mantine/core";
import { Suspense } from "react";

interface SuspenseWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const DefaultFallback = () => (
  <Flex justify="center" align="center" mih="400px" w="100%">
    <Loader />
  </Flex>
);

const SuspenseWrapper = ({ children, fallback }: SuspenseWrapperProps) => {
  return (
    <Suspense fallback={fallback || <DefaultFallback />}>{children}</Suspense>
  );
};

export default SuspenseWrapper;
